import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { DialogContainer, View } from '@adobe/react-spectrum';
import { Flex } from '@react-spectrum/layout';
import { EditorActions } from 'app/stores/editor/actions';
import { getPagesCount } from 'app/stores/selectors';
import { useAppDispatch } from 'app/stores/store';
import { SettingsDialog } from 'app/views/components/dialogs/SettingsDialog';
import { Pagination } from 'app/views/components/editor/platform/desktop/Pagination';
import { Sidebar } from 'app/views/components/editor/Sidebar';
import { Slides } from 'app/views/components/editor/Slides';
import { Workspace } from 'app/views/components/editor/Workspace';
import { FooterView } from 'app/views/components/Footer';
import { Controller } from './Controller';
import { FileDrop } from './FileDrop';
import { ProjectBackground } from './workspace/imageBackground/ProjectBackground';
import { ProjectCrop } from './workspace/imageCrop/ProjectCrop';
const WrapperStyles = { overflow: 'hidden' };
const EditorContent = () => {
    const hasMultiplePages = useSelector((state) => getPagesCount(state) > 1);
    const direction = configGet('desktopMainViewLayout', 'row');
    const showSlidesList = configGet('slidesListEnabled', false);
    const Wrapper = hasMultiplePages ? Pagination : React.Fragment;
    return (React.createElement(Flex, { direction: direction, height: "100%", width: "100%", minHeight: "0px", flex: "1 1 auto", UNSAFE_style: WrapperStyles },
        React.createElement(Sidebar, null),
        React.createElement(View, { flex: "1 1 auto", overflow: "hidden" },
            React.createElement(Flex, { height: "100%", width: "100%", direction: "row", alignItems: "stretch" },
                React.createElement(FileDrop, null,
                    React.createElement(Wrapper, null,
                        React.createElement(Workspace, null,
                            React.createElement(Controller, null)))),
                showSlidesList === true && React.createElement(Slides, null)))));
};
const Settings = () => {
    const dispatch = useAppDispatch();
    const isOpen = useSelector((state) => state.editor.TEMPORARY_settingsOpened);
    const onDismiss = useCallback(() => {
        dispatch(EditorActions.TEMPORARYsetSettingsOpened(false));
    }, [dispatch]);
    return (React.createElement(DialogContainer, { onDismiss: onDismiss }, isOpen && React.createElement(SettingsDialog, null)));
};
export const Editor = () => {
    const activeController = useSelector((state) => state.editor.activeController);
    let Content = EditorContent;
    switch (activeController) {
        case 'image-crop':
            Content = ProjectCrop;
            break;
        case 'image-background':
            Content = ProjectBackground;
            break;
        default:
            break;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Content, null),
        React.createElement(FooterView, null),
        React.createElement(Settings, null)));
};
